import i18n from "../../../config/locale/i18n";

export const awsAccountActions = {
  CREATE: "CREATE",
  MOVE: "MOVE",
  CREATE_BG: "CREATE_BG",
};

export const hierarchyTreeRadioButtonModes = {
  ALL: "all",
  NONE: "none",
};

export const accountDetailsTableRows = ["reviewLabel", "value"];
export const selectedOrgUnitTableRows = ["label", "value"];

export const tagsTableRows = ["Key", "Value"];
export const tagsTableColumns = [
  i18n.t("common:keyLabel"),
  i18n.t("common:valueLabel"),
];

export const accountFields = [
  {
    type: "text",
    required: true,
    key: "field-label-1",
    apiKey: "accountName",
    value: "",
    id: "field-label-1",
    minLength: 3,
    maxLength: 255,
    label: i18n.t("awsAccounts:createAccount.label.name"),
    reviewLabel: i18n.t("awsAccounts:createAccount.label.name"),
    placeholder: i18n.t("awsAccounts:createAccount.placeholder.name"),
    helpText: i18n.t("awsAccounts:createAccount.helpText.name"),
  },
  {
    type: "email",
    required: true,
    key: "field-label-2",
    apiKey: "email",
    value: "",
    id: "field-label-2",
    label: i18n.t("awsAccounts:createAccount.label.email"),
    reviewLabel: i18n.t("awsAccounts:createAccount.label.email"),
    placeholder: i18n.t("awsAccounts:createAccount.placeholder.email"),
    helpText: i18n.t("awsAccounts:createAccount.helpText.email"),
  },
  {
    type: "text",
    required: true,
    key: "field-label-3",
    apiKey: "primaryOwner",
    value: "",
    id: "field-label-3",
    minLength: 3,
    maxLength: 255,
    label: i18n.t("awsAccounts:createAccount.label.primaryOwner"),
    reviewLabel: i18n.t("awsAccounts:createAccount.label.primaryOwner"),
    placeholder: i18n.t("awsAccounts:createAccount.placeholder.primaryOwner"),
    helpText: i18n.t("awsAccounts:createAccount.helpText.primaryOwner"),
  },
];

export const ACCOUNT_DATA = "ACCOUNT_DATA";

export const CREATE_ACCOUNT_STEPS = {
  ENTER_ACCOUNT_DETAILS: 1,
  SELECT_ORG_UNIT: 2,
  APPLY_TAGS: 3,
  REVIEW: 4,
};
